export const Direction = {
    UP: -1,
    DOWN: 1,
    NO: 0,
} as const;

export const ContextHelpListAction = {
    ADD: 'add',
    REMOVE: 'remove',
} as const;

export type ContextHelpList = string[];

type ValueOf<T> = T[keyof T];
export type ContextHelpListOrderingTask = {
    action?: ValueOf<typeof ContextHelpListAction>;
    direction: ValueOf<typeof Direction>;
    guide: {
        id: string;
    };
};

export const changeContextHelpListOrder = (
    contextHelpList: ContextHelpList,
    { action, direction, guide }: ContextHelpListOrderingTask
): ContextHelpList => {
    // we need a copy of the items, [...contextHelpList] is not enough
    const newContextHelpList = [...contextHelpList];

    switch (action) {
        case ContextHelpListAction.ADD: {
            newContextHelpList.push(guide.id);
            break;
        }
        case ContextHelpListAction.REMOVE:
            newContextHelpList.splice(
                newContextHelpList.findIndex((guideId) => guideId === guide.id),
                1
            );
            break;
        default: {
            const currentItemIndex = newContextHelpList.findIndex((guideId) => guideId === guide.id);
            const newItemIndex = currentItemIndex + direction;

            if (newItemIndex < 0 || newItemIndex >= newContextHelpList.length) {
                return contextHelpList;
            }

            const tmp = newContextHelpList[currentItemIndex];
            newContextHelpList[currentItemIndex] = newContextHelpList[newItemIndex];
            newContextHelpList[newItemIndex] = tmp;
        }
    }

    return newContextHelpList;
};
